export default __webpack_public_path__ + "static/bb-9d421eaa076c4385850f80b820f165ae.png";